"use strict";

var dgv = dgv || {};

dgv.conceptVideo = dgv.conceptVideo || function () {

    function init(){
        let target = document.querySelector('.concept-video__container');

        if(!target) {
            return;
        }

        let video  = target.querySelector('video');
        let btn = target.querySelector('button');

            target.addEventListener('click', function () {
                target.classList.add('playing');
                video.play()
                btn.classList.add('hidden')
            });

            video.addEventListener('pause', () => {
                target.classList.remove('playing')
                btn.classList.remove('hidden')
                video.setAttribute('controls', false);
            })

            video.addEventListener('playing', () => {
                target.classList.add('playing')
                btn.classList.add('hidden')
                video.setAttribute('controls', true);
            })
    }

    return {
        init: init,
    };

}();
